// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Upojs","label":"Section_label__1W-Iw","contentWrap":"Section_contentWrap__1S0Jb","footer":"Section_footer__3JDHk","footerInner":"Section_footerInner__oDd0U"};